module.exports = __webpack_public_path__ + "static/img/15381c1f.png";